/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PdfUploadCompleteForm model module.
   * @module textbook/model/PdfUploadCompleteForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PdfUploadCompleteForm</code>.
   * @alias module:textbook/model/PdfUploadCompleteForm
   * @class
   * @param pdfFileUri {String} PDF文件OSS存储路径
   * @param pdfFileSize {Integer} PDF文件大小（字节）
   */
  var exports = function(pdfFileUri, pdfFileSize) {
    var _this = this;

    _this['pdfFileUri'] = pdfFileUri;
    _this['pdfFileSize'] = pdfFileSize;
  };

  /**
   * Constructs a <code>PdfUploadCompleteForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/PdfUploadCompleteForm} obj Optional instance to populate.
   * @return {module:textbook/model/PdfUploadCompleteForm} The populated <code>PdfUploadCompleteForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileUri')) {
        obj['pdfFileUri'] = ApiClient.convertToType(data['pdfFileUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileSize')) {
        obj['pdfFileSize'] = ApiClient.convertToType(data['pdfFileSize'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * PDF文件OSS存储路径
   * @member {String} pdfFileUri
   */
  exports.prototype['pdfFileUri'] = undefined;
  /**
   * PDF文件大小（字节）
   * @member {Integer} pdfFileSize
   */
  exports.prototype['pdfFileSize'] = undefined;



  export default exports;
;


